import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';

import { snDetailExpand, snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from 'libs/core/src/lib/components/table-base.component';

import { FsWhoosterPhoneModel } from '../../models/whooster-phone.model';

@Component({
  selector: 'sn-whooster-phone-table',
  templateUrl: './whooster-phone-table.component.html',
  styleUrls: ['./whooster-phone-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut, snDetailExpand],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FsWhoosterPhoneTableComponent
  extends SnTableBaseComponent<FsWhoosterPhoneModel>
  implements OnInit
{
  private _expanded = [];

  @Output() public readonly whoosterDownload = new EventEmitter<String>();

  constructor(private readonly _cd: ChangeDetectorRef) {
    super();
  }

  public ngOnInit(): void {}

  public isExpanded(id: string): boolean {
    return this._expanded.indexOf(id) > -1;
  }

  public toggleExpanded(item: any): void {
    if (this.isExpanded(item.uuid)) {
      this._expanded = [];
    } else {
      this._expanded = [item.uuid];
      this._cd.detectChanges();
    }
  }

  public whoosterPdf(item: any): void {
    this.whoosterDownload.next(item.uuid);
  }

  public isArrays(item: any): boolean {
    return Array.isArray(item);
  }

  public trackBy(index: number, item: FsWhoosterPhoneModel): string {
    return item.uuid;
  }
}
